
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((|1)79|373|400|77|956|961)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
